// extracted by mini-css-extract-plugin
export default {"gallery":"c-l_gZ","gallery__header":"c-l_ha","gallery__thumbs":"c-l_hb"};